<template>
  <!--  <div :style="{ paddingRight: issue.show_unknown ? '120px' : 0 }" class="relative inline-block max-w-full box-border">
      <q-table ref="qTable" :view="view" :rows="issue.items" row-key="id" :columns="issue.labels" :row-desc="issue.rowDesc">
        <template v-slot:column-header="{ col }">
          <div class="py-2 text-center">
            <span v-if="issue.show_option_desc" v-html="col.text"></span>
            <br />
            <span v-if="issue.show_option_value">{{ col.num }}</span>
            <template v-if="view && enableAnswerScore">
              <br />
              <span>{{ getScore(col.num) }}</span>
            </template>
          </div>
        </template>
        <template v-slot:content="{ row, col }">
          <div @click="row.value = col.id" class="text-center use-hover">
            <el-radio :value="row.value" :label="col.id">
              <span></span>
            </el-radio>
          </div>
        </template>
      </q-table>
      <div class="absolute right-0 top-0" v-if="issue.show_unknown">
        <table class="q-table q-table-border" border="1" cellpadding="0" cellspacing="0">
          <thead>
            <tr ref="tableHead">
              <th>
                <div class="text-center">
                  <span>{{ issue.unknown_text }}</span>
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr ref="tr" v-for="(row, index) in issue.items" :key="row.id">
              <td :key="row.id" class="relative">
                <div @click="row.value = 'unknown'" class="text-center">
                  <el-radio :value="row.value" label="unknown">
                    <span></span>
                  </el-radio>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>-->
  <div ref="container">
    <div>
      <div class="flex mb-2">
        <div class="scale-label" ref="headLabel"></div>
        <div class="scale-head-text">
          <div v-for="(i, idx) in issue.labels" :key="idx" class="scale-label-value-wrapper"
               :style="{ width: scaleItemWidth }">
            <div class="scale-head-text-item">
              <span v-html="i.text"></span>
            </div>
          </div>
          <template v-if="issue.enabledAuxiliaryColumn">
            <div class="inline-block" :style="{ width: auxiliaryWidth + 20 +'px' }"></div>
          </template>
          <div v-if="issue.show_unknown" class="scale-label-value-wrapper" :style="{ width: scaleItemWidth }">
            <div class="scale-head-text-item">
              <span>{{ issue.unknown_text }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-for="(item,index) in issue.items" :key="item.id" class="flex mb-2 last:mb-0">
        <div ref="labels" class="scale-label" v-html="item.content.richText"></div>
        <div class="scale-value flex-1">
          <div
              v-for="(i, idx) in issue.labels"
              :key="idx"
              :style="{ width: scaleItemWidth }"
              class="scale-label-value-wrapper"
          >
            <div class="scale-value-item" :style="getActiveColor(item.value, idx)" @click="onChange(item,i.id)">
              <span>{{ i.num }}</span>
            </div>
          </div>
        </div>
        <template v-if="issue.enabledAuxiliaryColumn">
          <div ref="auxiliary" class="ml-5" v-html="issue.auxiliaryColumns[index].content.richText"></div>
        </template>
        <div v-if="issue.show_unknown" class="scale-value">
          <div class="scale-label-value-wrapper" :style="{ width: scaleItemWidth }">
          <div
              class="scale-value-item"
              :style="{ backgroundColor: item.value === 'unknown' ? issue.activeColor : '' }"
              @click="onChange(item,'unknown')"
          >
            <br />
            <span> </span>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QTable from '@/questions/components/QTable'

export default {
  name: 'MatrixScale',
  components: { QTable },
  changeExpr: 'isSelectAll',
  data() {
    return {
      width: 0,
      labelWidth: 0,
      auxiliaryWidth: 0
    }
  },
  computed: {
    scaleItemWidth() {
      const labelWidth = this.labelWidth
      const auxiliaryWidth = this.auxiliaryWidth
      let labelMarginRight = 20
      let len = this.issue.labels.length
      if (this.issue.show_unknown) {
        len += 1
      }
      if(this.issue.enabledAuxiliaryColumn){
        labelMarginRight = labelMarginRight * 2
      }
      return Math.floor((this.width - labelWidth - auxiliaryWidth - labelMarginRight) / len) + 'px'
    },
    isSelectAll() {
      let val = this.issue.items.every(item => item.value !== null)
      if (!val) return 'false'
      return this.issue.items.map(i => i.value).join('-')
    },
    enableAnswerScore() {
      return this.question.setting.enableAnswerScore
    }
  },
  methods: {
    getActiveColor(activeValue, idx) {
      return this.issue.getActiveColor(activeValue, idx)
    },
    init() {
      this.width = this.$refs.container.clientWidth
      let labels = this.$refs.labels
      let labelWidth = 0
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i]
        labelWidth = Math.max(labelWidth, Math.min(label.clientWidth, 200))
      }



      labelWidth += 10
      for (let i = 0; i < labels.length; i++) {
        const label = labels[i]
        label.style.width = labelWidth + 'px'
      }
      this.$refs.headLabel.style.width = labelWidth + 'px'
      this.labelWidth = labelWidth

      if(this.issue.enabledAuxiliaryColumn) {
        let auxiliarys = this.$refs.auxiliary
        let auxiliaryWidth = 0
        for (let i = 0; i < auxiliarys.length; i++) {
          const auxiliary = auxiliarys[i]
          auxiliaryWidth = Math.max(auxiliaryWidth, Math.min(auxiliary.clientWidth, 200))
        }
        this.auxiliaryWidth = auxiliaryWidth + 10

        for (let i = 0; i < auxiliarys.length; i++) {
          const auxiliary = auxiliarys[i]
          auxiliary.style.width = auxiliaryWidth +'px'
        }
      }
      // if (!this.issue.show_unknown) return
      //
      // let headerHeight = this.$refs.qTable.getHeaderHeight()
      // this.$refs.tableHead.style.height = headerHeight + 'px'
      //
      // let rowsHeight = this.$refs.qTable.getRowsHeight()
      // const rows = this.$refs.tr
      // for (let i = 0; i < rowsHeight.length; i++) {
      //   const rowHeight = rowsHeight[i]
      //   rows[i].style.height = rowHeight + 'px'
      // }
    },
    getScore(value) {
      const optionScoreItems = this.question.answerScore.optionScoreItems
      const opt = optionScoreItems.find(opt => (opt.value || '').toString() === value.toString())
      if (opt) {
        return `${opt.score}分`
      } else {
        return ''
      }
    },
    onChange(item, value) {
      if (this.view) return
      item.value = value
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  }
}
</script>

<style lang="scss" scoped>
.scale-label {
  margin-right: 20px;
}

.scale-label-value-wrapper {
  display: inline-block;
  //padding: 0 4px;
  box-sizing: border-box;
}

.scale-head-text-item {
  text-align: center;
  word-break: break-word;
}

.scale-value {
  .scale-value-item {
    height: 28px;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
    @apply bg-card-bg-gray;

    &:last-child {
      margin-right: 0;
    }

    &.scale-active {
      @apply bg-theme text-white;
    }
  }
}
</style>
